import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import CategoryView from "../views/AllCategoriesView.vue";
import CategoryAsProductView from "../views/CategoryAsProductView.vue";
import AllProductsView from "../views/AllProductsView.vue";
import ProductView from "../views/ProductView.vue";
import CategoryPage from "../views/CategoryPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    children: [
      {
        path: "/",
        name: "allCategories",
        component: CategoryView,
      },
      {
        path: "/category/:categoryIdentifier",
        name: "categoryPage",
        component: CategoryPage,
      },
      {
        path: "/products",
        name: "allProducts",
        component: AllProductsView,
      },
      {
        path: "/category-product/:categoryIdentifier",
        name: "categoryProductPage",
        component: CategoryAsProductView,
      },
    ],
  },
  {
    path: "/product/:productId",
    name: "productPage",
    component: ProductView,
  },
  
];

const router = new VueRouter({
  routes,
});

export default router;
